/* Reveal dialog: pure model. The reason rule and the text of a revealed value. */
import type { EnvVarRevealResponse } from '@/api/schemas';

export const MIN_REASON_LENGTH = 3;

/** The reason is written to the audit log; the error only shows after the first submit. */
export function revealReasonError(reason: string, submitted: boolean): string | undefined {
  return submitted && reason.trim().length < MIN_REASON_LENGTH ? 'Give a reason of at least 3 characters (it is written to the audit log)' : undefined;
}

/** The revealed text: `value`, or the decoded base64 of a file variable; empty when neither came back. */
export function revealedValue(result: Pick<EnvVarRevealResponse, 'value' | 'valueBase64'> | null): string {
  return result?.value ?? (result?.valueBase64 ? atob(result.valueBase64) : '');
}

export type RevealStep = 'secret' | 'revealed' | 'ask';

/** Secrets are never revealable; once revealed the value replaces the reason field. */
export function revealStep(secret: boolean, revealed: boolean): RevealStep {
  if (secret) return 'secret';
  return revealed ? 'revealed' : 'ask';
}
